import { useContext, useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { SiteContext } from "../context/SiteContext";
import { api } from "../services/api";
import "./NoticiaAberta.css";

export default function NoticiaAberta() {
  const { config, loading: configLoading } = useContext(SiteContext);
  const { id } = useParams(); // Pega o ID da notícia que está na URL
  const [noticia, setNoticia] = useState(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(false);

  useEffect(() => {
    async function fetchNoticia() {
      try {
        setLoading(true);
        // Ajuste a rota abaixo para a rota exata do seu back-end que busca 1 notícia
        const response = await api.get(`/noticias/${id}`); 
        setNoticia(response.data);
      } catch (error) {
        console.error("Erro ao buscar a notícia:", error);
        setErro(true);
      } finally {
        setLoading(false);
      }
    }

    if (id) {
      fetchNoticia();
    }
  }, [id]);

  const formatarData = (dataString) => {
    if (!dataString) return "";
    const data = new Date(dataString);
    return data.toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric' });
  };

  if (configLoading || loading) return <div className="noticia-loading">Carregando notícia...</div>;
  if (erro || !noticia) return <div className="noticia-loading">Notícia não encontrada.</div>;

  return (
    <div className="noticia-aberta-page">
      <div className="container noticia-aberta-container">

        {/* Cabeçalho da Notícia */}
        <header className="noticia-aberta-header">
          <span className="noticia-aberta-data">
            Publicado em {noticia.data || formatarData(noticia.createdAt)}
          </span>
          <h1 className="noticia-aberta-titulo">{noticia.titulo}</h1>
        </header>

        {/* Imagem Principal (se houver) */}
        {noticia.imagem && (
          <div className="noticia-aberta-imagem">
            <img src={noticia.imagem} alt={noticia.titulo} />
          </div>
        )}

        {/* Corpo do Texto */}
        <div className="noticia-aberta-conteudo">
          {/* Se o seu texto vier com tags HTML do banco (ex: de um editor como o Quill/CKEditor),
            use a div abaixo com dangerouslySetInnerHTML e comente a tag <p>
          */}
          {/* <div dangerouslySetInnerHTML={{ __html: noticia.conteudo }}></div> */}
          
          {/* Se o texto for apenas texto puro, use assim: */}
          <p>{noticia.conteudo || noticia.descricao}</p>
        </div>

      </div>
    </div>
  );
}